<template>
  <MakerCartGuideLayout
    pageTitle="About the Maker Cart"
    heroImage="/images/maker-cart-guide/frame-1000006403.png"
    previousUrl="/makercart/guide/2"
    nextUrl="/makercart/guide/4"
  >
    <div class="x-guide3-content">
      <div class="x-intro-box">
        <div class="x-quotes">
          <img
            src="/images/maker-cart-guide/top-comma.svg"
            alt="Quote"
            class="x-quote-img"
          />
        </div>
        <p class="x-intro-text">
          The Makercart Activities are designed for students to explore their
          ideas; to prototype, iterate, and test, and, in the process, adopt the
          Maker Mindset. The activities are designed to follow a “Low Floor,
          High Ceiling, Wide Wall” principle, with starting activities (‘low
          floor’) accessible to all learners, and can be differentiated for
          high-ability learners (‘high ceiling’), and able to support the
          diverse learning needs of our students (‘wide walls’). The Makercart
          comes with Activity Guides, Instructional Material for each activity,
          and the Makercart itself.
        </p>
      </div>

      <h2 class="x-section-title">
        What resources are provided with the Makercart?
      </h2>

      <div class="x-cards-container">
        <!-- Resource Card 1 -->
        <div class="x-resource-card x-card-pink">
          <div class="x-card-header">
            <img
              src="/images/maker-cart-guide/document-text.svg"
              alt="Guide"
              class="x-card-icon"
            />
            <h3 class="x-card-title">Maker Activity Guide</h3>
          </div>
          <p class="x-card-text">
            The Activity Guides for each Makercart Activity provide detailed
            notes for teachers about how to implement the activity in their
            classroom. Recommended materials - and quantities per student - are
            provided, alongside suggestions on how each section of the activity
            can be carried out. Standards are also provided for each activity,
            for clear alignment to academic concepts.
          </p>
        </div>

        <!-- Resource Card 2 -->
        <div class="x-resource-card x-card-purple">
          <div class="x-card-header">
            <img
              src="/images/maker-cart-guide/poster-2.svg"
              alt="Poster"
              class="x-card-icon"
            />
            <h3 class="x-card-title">Instructional Material</h3>
          </div>
          <p class="x-card-text">
            A slide deck, along with student handouts, are provided for each
            activity. Teachers should use the slides to introduce the student to
            the activity, and engage the entire class. Thereafter, students will
            refer to their individual handouts to complete the Maker Activity.
            This fosters self-directed learning. Finally, teachers should use
            the slides to reengage students in sharing their creations and
            reflecting about the activity.
          </p>
        </div>

        <!-- Resource Card 3 -->
        <div class="x-resource-card x-card-blue">
          <div class="x-card-header">
            <img
              src="/images/maker-cart-guide/layer-1.svg"
              alt="MakerCart"
              class="x-card-icon"
              style="height: 40px"
            />
            <h3 class="x-card-title">Makercart</h3>
          </div>
          <p class="x-card-text">
            The Maker Cart is a materials cart where materials are visible to
            the students to be creative in building their prototypes. Almost all
            materials that are needed for your chosen Maker Activities are
            provided, and can be stored within the cart. Additionally, the
            storage boxes and side panels are colour-coded for ease of giving
            instructions to students.
          </p>
        </div>
      </div>
    </div>
  </MakerCartGuideLayout>
</template>

<script setup>
import MakerCartGuideLayout from "@/components/maker-cart/MakerCartGuideLayout.vue";
</script>

<style scoped>
.x-guide3-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.x-intro-box {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.x-quotes {
  display: flex;
  gap: 17px;
}

.x-quote-img {
  width: 103px;
  height: 60px;
}

.x-intro-text {
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: var(--fs-medium);
  line-height: 24px;
  letter-spacing: 0.08px;
  color: #3b4648;
  margin: 0;
  white-space: pre-wrap;
}

.x-section-title {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-xl);
  line-height: 32px;
  color: var(--primary-blue);
  margin: 0;
  padding: 0 16px;
}

.x-cards-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.x-resource-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border-radius: 16px;
  overflow: hidden;
  color: #ffffff;
}

.x-card-pink {
  background-color: #e00069;
}

.x-card-purple {
  background-color: #4c4ddc;
}

.x-card-blue {
  background-color: var(--primary-blue);
}

.x-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.x-card-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.x-card-blue .x-card-icon {
  width: 26.4px;
  height: 40px;
}

.x-card-title {
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: var(--fs-xl);
  line-height: 32px;
  margin: 0;
}

.x-card-text {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: var(--fs-medium);
  line-height: 24px;
  letter-spacing: 0.08px;
  margin: 0;
}
.x-card-pink .x-card-text {
  font-size: var(--fs-small);
  line-height: 20px;
  letter-spacing: 0.035px;
}
</style>
